<nav *ngIf="!isRoot && canNavigateBack">
  <a [routerLink]="breadcrumb?.url" [queryParams]="breadcrumb?.queryParams">
    <span class="" [translate]="breadcrumb?.label"></span>
  </a>
</nav>

<h1 *ngIf="isTitleVisible" [class.center]="alignCenterTitle">
  {{ title || (this.routeTitle | translate) }}
  @if (tooltip) {
    <span>
      <svg-icon-sprite
        [src]="'./assets/img/icons/sprite.svg#hint'"
        [matTooltip]="tooltip"
        matTooltipPosition="above"
        matTooltipShowDelay="100"
        width="16px"
        height="16px"
      ></svg-icon-sprite>
    </span>
  }
</h1>